(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("axios"), require("bxl-utils"));
	else if(typeof define === 'function' && define.amd)
		define("bxl-legocore", ["react", "axios", "bxl-utils"], factory);
	else if(typeof exports === 'object')
		exports["bxl-legocore"] = factory(require("react"), require("axios"), require("bxl-utils"));
	else
		root["bxl-legocore"] = factory(root["React"], root["axios"], root["BxlUtils"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__10__, __WEBPACK_EXTERNAL_MODULE__11__) {
return 